import {head} from 'ramda';
import {isNotNil} from 'ramda-adjunct';

import {InspectionType} from '@dms/api/core';

import {useThunkDispatch} from '../../../hooks/useThunkDispatch';
import {getAuditStructure, getCondition} from '../../../store/carAudit/actions';
import {selectCarAudit} from '../../../store/carAudit/selectors';

export function useGetVehicleCondition() {
  const dispatch = useThunkDispatch();

  const {loading: loadingAuditStructure} = getAuditStructure.useThunkState(selectCarAudit);
  const {loading: loadingCondition} = getCondition.useThunkState(selectCarAudit);

  const isLoading = loadingAuditStructure || loadingCondition;

  const getVehicleCondition = (vehicleId: string) =>
    dispatch(
      getCondition.action({
        requestBody: {vehicleIds: [vehicleId]},
        inspectionType: InspectionType.VEHICLE_CONDITION,
      })
    )
      .unwrap()
      .then((response) => {
        if (isNotNil(response)) {
          const data = head(response);

          if (isNotNil(data?.controlStructureId)) {
            dispatch(getAuditStructure.action({auditStructureId: data?.controlStructureId}));
          }
        }
      });

  return {getVehicleCondition, isLoading};
}
